import React from 'react';
import { Outlet, Link } from 'react-router-dom';

const Layout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-earth-100">
      <header className="bg-white shadow-natural">
        <nav className="container mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3">
              <span className="text-3xl font-montessori font-bold text-clay-500">
                Ann Schaefer
                <span className="text-sage-400">Childcare</span>
              </span>
            </Link>
            <div className="hidden md:flex space-x-6 font-montessori">
              <Link to="/" className="text-earth-400 hover:text-clay-400 transition-colors">Home</Link>
              <Link to="/policy" className="text-earth-400 hover:text-clay-400 transition-colors">Policies</Link>
              <Link to="/schedule" className="text-earth-400 hover:text-clay-400 transition-colors">Schedule</Link>
              <Link to="/safety" className="text-earth-400 hover:text-clay-400 transition-colors">Safety</Link>
              <Link to="/gallery" className="text-earth-400 hover:text-clay-400 transition-colors">Gallery</Link>
              <Link to="/contact" className="btn-natural">Contact Us</Link>
            </div>
          </div>
        </nav>
      </header>
      
      <main className="flex-grow container mx-auto px-4 py-8">
        <Outlet />
      </main>
      
      <footer className="bg-earth-500 text-earth-100">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-xl font-montessori mb-4">Contact Us</h3>
              <p className="mb-2">2713 Webb Road</p>
              <p className="mb-2">Lafayette, New York 13084</p>
              <p className="mb-2">Phone: (315) 395-6193</p>
              <p>Email: annkatniss@gmail.com</p>
            </div>
            <div>
              <h3 className="text-xl font-montessori mb-4">Hours</h3>
              <p className="mb-2">Monday - Friday</p>
              <p className="mb-2">7:15 AM - 4:30 PM</p>
              <p>Weekends Closed</p>
            </div>
            <div>
              <h3 className="text-xl font-montessori mb-4">Quick Links</h3>
              <div className="flex flex-col space-y-2">
                <Link to="/policy" className="text-earth-100 hover:text-sage-200 transition-colors">Policies</Link>
                <Link to="/schedule" className="text-earth-100 hover:text-sage-200 transition-colors">Daily Schedule</Link>
                <Link to="/safety" className="text-earth-100 hover:text-sage-200 transition-colors">Safety Information</Link>
                <Link to="/gallery" className="text-earth-100 hover:text-sage-200 transition-colors">Gallery</Link>
                <a href="https://kinside.com" target="_blank" rel="noopener noreferrer" className="text-earth-100 hover:text-sage-200 transition-colors">
                  Find us on Kinside
                </a>
              </div>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-earth-400 text-center">
            <p>&copy; {new Date().getFullYear()} Ann Schaefer Childcare. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout; 